import { maybeBundleOverride } from './bundleOverride';
import { ROUTER_BASENAME } from './dev-console/path-prefixes';

const ConsoleImport = () => import('./dev-console');
const InstallImport = () => import('./forge-distribution');

const fetchAuth = async () => {
  const auth = await fetch('/api/console-auth/');
  if (auth.status === 403) {
    // User is not logged in
    const returnTo = `?returnTo=${encodeURIComponent(location.pathname + location.search)}`;
    location.href = `/account/login${returnTo}`;
    return;
  }
  return auth.json();
};
async function main() {
  // Handle the bundle override first, as the override can do everything else itself
  if (maybeBundleOverride()) {
    return;
  }

  injectRootElement();

  const authPromise = fetchAuth();
  let modulePromise: Promise<{ main: () => void }>;

  if (location.pathname.startsWith(`${ROUTER_BASENAME}/install/`)) {
    modulePromise = InstallImport();
  } else {
    modulePromise = ConsoleImport();
  }

  const [auth, module] = await Promise.all([authPromise, modulePromise]);
  setupAuth(auth);
  module.main();
}

function injectRootElement() {
  if (document.querySelector('#root')) {
    return;
  }
  const root = document.createElement('div');
  root.id = 'root';
  document.body.appendChild(root);
}

export interface CustomWindow extends Window {
  __DATA__?: Record<string, unknown>;
  csrfToken?: string;
}

function setupAuth(auth: { props: Record<string, unknown>; csrfToken?: string }) {
  (window as CustomWindow).__DATA__ = auth.props;
  (window as CustomWindow).csrfToken = auth.csrfToken;
}

void main();
